import { Navigate, useLocation } from "react-router-dom";

/** Preserves ?ref= and UTM when linking to /login from referral landing. */
const LoginReferralRedirect = () => {
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: "/auth/login", search: location.search }}
      replace
    />
  );
};

export default LoginReferralRedirect;
